import moment from "moment";

export function formatDate(date, format = "l HH:mm") {
	return moment(date).format(format);
}
